/* Dance & Animate: Produktnamen in Karten aufteilen (Modell / Farbe), interne Lager-Nr. ausblenden */
(function () {
  function clean(el) {
    if (!el || el.dataset.dna) return;
    var t = (el.textContent || '').trim();
    if (!t) return;
    t = t.replace(/^PL\d+\s+/, '').replace(/^Pleaser\s+/, '');
    var parts = t.split(' – ');
    el.textContent = '';
    var a = document.createElement('span');
    a.className = 'dna-name';
    a.textContent = parts[0];
    el.appendChild(a);
    if (parts.length > 1) {
      var b = document.createElement('span');
      b.className = 'dna-color';
      b.textContent = parts.slice(1).join(' – ');
      el.appendChild(b);
    }
    el.dataset.dna = '1';
  }
  function run(root) {
    (root || document).querySelectorAll('.card__heading a, .predictive-search__item-heading').forEach(clean);
  }
  document.addEventListener('DOMContentLoaded', function () { run(); });
  new MutationObserver(function (m) {
    m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* WebApp-Button, Installation, Sprachumschalter und Schnelleinstieg */
(function () {
  var deferred = null;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var P = EN ? '/en' : '';
  function T(de, en) { return EN ? en : de; }
  window.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); deferred = e; });
  var cfg = window.dnaApp || {};
  function addHead() {
    if (!cfg.icon) return;
    var h = document.head;
    var icon = cfg.icon.indexOf('//') === 0 ? 'https:' + cfg.icon : cfg.icon;
    var m = {
      name: cfg.name || 'Dance & Animate', short_name: 'D&A',
      start_url: location.origin + P + '/?app=1', scope: location.origin + '/', display: 'standalone',
      background_color: '#ffffff', theme_color: '#d77db1',
      icons: [{ src: icon.replace(/width=\d+/, 'width=192').replace(/height=\d+/, 'height=192'), sizes: '192x192', type: 'image/jpeg' },
              { src: icon, sizes: '512x512', type: 'image/jpeg' }]
    };
    if (!document.querySelector('link[rel="manifest"]')) {
      var l = document.createElement('link'); l.rel = 'manifest';
      l.href = 'data:application/manifest+json,' + encodeURIComponent(JSON.stringify(m)); h.appendChild(l);
    }
    var a = document.createElement('link'); a.rel = 'apple-touch-icon'; a.href = icon.replace(/width=\d+/, 'width=180').replace(/height=\d+/, 'height=180'); h.appendChild(a);
    [['apple-mobile-web-app-capable', 'yes'], ['mobile-web-app-capable', 'yes'], ['apple-mobile-web-app-title', 'D&A'], ['theme-color', '#d77db1']].forEach(function (p) {
      var t = document.createElement('meta'); t.name = p[0]; t.content = p[1]; h.appendChild(t);
    });
  }
  function isIOS() { return /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }
  function sheet() {
    var s = document.getElementById('dna-app-sheet');
    if (!s) {
      s = document.createElement('div'); s.id = 'dna-app-sheet'; s.className = 'dna-app-sheet'; s.hidden = true;
      s.setAttribute('role', 'dialog'); s.setAttribute('aria-modal', 'true'); s.setAttribute('aria-label', T('Als App installieren', 'Install as app'));
      var steps = isIOS()
        ? T('<li>Tippe unten in Safari auf <b>Teilen</b> (Quadrat mit Pfeil).</li><li>Wähle <b>„Zum Home-Bildschirm“</b>.</li><li>Tippe auf <b>Hinzufügen</b> – fertig.</li>',
            '<li>In Safari, tap <b>Share</b> (square with arrow) at the bottom.</li><li>Choose <b>“Add to Home Screen”</b>.</li><li>Tap <b>Add</b> – done.</li>')
        : T('<li>Öffne das Browser-Menü <b>⋮</b> oben rechts.</li><li>Wähle <b>„App installieren“</b> oder <b>„Zum Startbildschirm hinzufügen“</b>.</li><li>Bestätige mit <b>Installieren</b>.</li>',
            '<li>Open the browser menu <b>⋮</b> at the top right.</li><li>Choose <b>“Install app”</b> or <b>“Add to Home screen”</b>.</li><li>Confirm with <b>Install</b>.</li>');
      s.innerHTML = '<div class="dna-app-sheet__box"><p class="dna-eyebrow">' + T('Dance &amp; Animate als App', 'Dance &amp; Animate as an app') + '</p><h2>' + T('Shop auf den Startbildschirm legen', 'Add the shop to your home screen') + '</h2><ol>' + steps + '</ol><button type="button" class="button" data-close>' + T('Verstanden', 'Got it') + '</button></div>';
      s.addEventListener('click', function (e) { if (e.target === s || e.target.hasAttribute('data-close')) s.hidden = true; });
      document.body.appendChild(s);
    }
    s.hidden = false;
  }
  function install() {
    if (deferred) { deferred.prompt(); deferred.userChoice.finally(function () { deferred = null; }); }
    else sheet();
  }
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2"/><path d="M12 7v7M9 11l3 3 3-3"/></svg>';
  function addButton() {
    if (window.matchMedia('(display-mode: standalone)').matches || navigator.standalone) return;
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.dna-app-btn')) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'dna-app-btn';
    b.setAttribute('aria-label', T('Shop als App installieren', 'Install shop as app'));
    b.innerHTML = ICON + '<span>WebApp</span>'; b.addEventListener('click', install);
    icons.insertBefore(b, icons.firstChild);
  }
  function addLang() {
    var icons = document.querySelector('.header__icons');
    var th = document.getElementById('dna-lang-h');
    if (icons && th && !icons.querySelector('.dna-lang')) icons.insertBefore(th.content.cloneNode(true), icons.firstChild);
    var util = document.querySelector('.menu-drawer__utility-links');
    var td = document.getElementById('dna-lang-d');
    if (util && td && !util.querySelector('.dna-lang')) util.insertBefore(td.content.cloneNode(true), util.firstChild);
  }
  function addDrawer() {
    var nav = document.querySelector('.menu-drawer__navigation-container');
    if (!nav || nav.querySelector('.dna-drawer-extra')) return;
    var d = document.createElement('div'); d.className = 'dna-drawer-extra';
    d.innerHTML = '<p class="dna-eyebrow">' + T('Nach Absatzhöhe', 'By heel height') + '</p><div class="dna-heels">' +
      '<a class="dna-pill" href="' + P + '/collections/absatz-15-cm"><strong>15 cm</strong></a>' +
      '<a class="dna-pill" href="' + P + '/collections/absatz-18-cm"><strong>18 cm</strong></a>' +
      '<a class="dna-pill" href="' + P + '/collections/absatz-20-cm"><strong>20 cm</strong></a></div>' +
      '<div class="dna-drawer-links"><a href="' + P + '/pages/ratgeber#groesse"><b>' + T('Größenberatung', 'Size guide') + '</b><span>EU / US</span></a>' +
      '<a href="' + P + '/pages/ratgeber#faq"><b>' + T('Fragen &amp; Antworten', 'Questions &amp; answers') + '</b><span>' + T('Abholung, Bar, Versand', 'Pickup, cash, shipping') + '</span></a>' +
      '<a href="' + P + '/collections/letzte-paare"><b>' + T('Letzte Paare', 'Last pairs') + '</b><span>' + T('Restgrößen', 'Remaining sizes') + '</span></a>' +
      '<button type="button" data-app><b>WebApp</b><span>' + T('Auf den Startbildschirm', 'Add to home screen') + '</span></button></div>';
    d.querySelector('[data-app]').addEventListener('click', install);
    var util = nav.querySelector('.menu-drawer__utility-links');
    nav.insertBefore(d, util || null);
  }
  function init() { addHead(); addLang(); addButton(); addDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
